var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "28", height: "28", viewBox: "-1 -1 28 28", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Airbnb"
    ),
    React.createElement(
      "g",
      { fill: "#fff" },
      React.createElement("circle", { cx: "13", cy: "13", r: "13" }),
      React.createElement("path", { d: "M7.73 15.443a11.906 11.906 0 0 0 .001-.003zm10.84.332a7.908 7.908 0 0 0-.034-.067l.019.042.014.025zm1.084.339c.1.432.131.83.083 1.257-.116.963-.79 1.781-1.764 2.199a3.07 3.07 0 0 1-1.434.168c-.443-.054-.883-.211-1.404-.496-.597-.373-1.206-.884-1.874-1.586l-.27-.285-.24.272c-.636.719-1.252 1.236-1.913 1.614-.494.27-.934.427-1.385.482-.505.055-.967 0-1.427-.17-.946-.347-1.646-1.213-1.764-2.201a3.115 3.115 0 0 1 .156-1.404c.061-.238.124-.41.25-.655.052-.085.1-.174.162-.302-.035.072.105-.219.176-.363l.018-.083c.928-2.025 1.96-4.09 3.466-6.986l.067-.128c.05-.084.089-.154.173-.32l.062-.121c.053-.1.099-.183.112-.193a2.41 2.41 0 0 1 .522-.803 2.13 2.13 0 0 1 1.622-.732c.628 0 1.194.253 1.645.76a7.611 7.611 0 0 1 .61.968l.062.122c.085.165.122.235.192.353l.046.09a224.219 224.219 0 0 1 3.44 6.937c.073.12.12.216.219.428.082.176.118.25.165.326l.038.075-.02-.042c.17.333.241.541.209.819z" }),
      React.createElement("path", { d: "M14.908 11.737l.003.015c.057.36.043.734-.047 1.07-.188.846-.691 1.839-1.462 2.882l-.393.533-.405-.524c-.777-1.007-1.281-2.003-1.466-2.885-.093-.393-.105-.723-.055-.999 0-.32.111-.64.3-.907.355-.502.974-.83 1.617-.83.675 0 1.29.31 1.66.906.114.239.202.493.248.739z" })
    )
  );
});